import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { DocumentText } from '@r1-frontend/ui-react/components/svg/content';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import Skeleton from '~/src/features/_layout/Header/commonComponents/AgreementInfo/Skeleton';
import { selectClientPersonalForHeader } from '~/src/store/selectors/auth/selectClientPersonal';

import * as ST from './styled';

export const Agreement = () => {
    const router = useRouter();
    const userInfo = useSelector(selectClientPersonalForHeader);

    const clickHandler = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.agreementMenu,
            action: 'iam_moving',
        });
        router.push('/lk/management');
    };

    return (
        <ST.Wrapper className='ym-hide-content'>
            <ST.Info>
                <DocumentText size={20}/>
                <Skeleton isLoading={!userInfo}>
                    {userInfo
                        ? <Paragraph4 $smaller>Договор {userInfo.agreement}<br/>По адресу {userInfo.address}</Paragraph4>
                        : null}
                </Skeleton>
            </ST.Info>
            <ButtonGroup size={'small'}>
                <Button
                    onClick={clickHandler}
                    bType={'secondary'}
                    size={'small'}
                >
                    Управление договором
                </Button>
            </ButtonGroup>
        </ST.Wrapper>
    );
};
